{
     AOS.init();
}
        {
            const homeBnrSwiper = new Swiper('.home_bnr_swiper', {
                loop: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 1000,
            });
        }
        {
            const testiSwiper = new Swiper('.testi_slider', {
                loop: false,
                navigation: {
                    nextEl: '.testi_swiper_next',
                    prevEl: '.testi_swiper_prev',
                },
                speed: 800,
                on: {
                    init(swiper) {
                        updateNavState(swiper);
                    },
                    slideChange(swiper) {
                        updateNavState(swiper);
                    }
                }
            });

            function updateNavState(swiper) {
                const prev = document.querySelector('.testi_swiper_prev');
                const next = document.querySelector('.testi_swiper_next');

                if (!prev || !next) return;

                // Remove disabled state first
                prev.classList.remove('swiper-disabled');
                next.classList.remove('swiper-disabled');

                // Add when needed
                if (swiper.isBeginning) prev.classList.add('swiper-disabled');
                if (swiper.isEnd) next.classList.add('swiper-disabled');
            }
        }
        {
            const servicesOfferSwiper = new Swiper('.services_offer_slider', {
                loop: true,
                navigation: {
                    nextEl: '.services_offer_next',
                    prevEl: '.services_offer_prev',
                },
                speed: 800,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 1.9,
                        spaceBetween: 15,
                    },
                    1025: {
                        slidesPerView: 2.5,
                        spaceBetween: 17,
                    },
                    1920: {
                        slidesPerView: 3.1,
                        spaceBetween: 17,
                    },
                    1900: {
                        slidesPerView: 4.2,
                        spaceBetween: 17,
                    }
                },
            });
        }

        {
   const logolist_slider = new Swiper(".logoSlider ", {
            slidesPerView: "auto",
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 4000,
            breakpoints: {
                150: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 20,
                },
                769: {
                    spaceBetween: 30,
                },
                1025: {
                    spaceBetween: 40,
                },
            }
        });
}

    document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");

    if (accordionItems.length > 0) {
        // Sirf pehla open hoga
        accordionItems.forEach((item, index) => {
            if (index === 0) {
                item.classList.add("open");
            } else {
                item.classList.remove("open");
            }
        });
    }

    accordionItems.forEach((item) => {
        const header = item.querySelector(".accordion-item-header");

        header.addEventListener("click", () => {
            accordionItems.forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.classList.remove("open");
                }
            });
            item.classList.toggle("open");
        });
    });
});
